import {ensureActions} from '../type'

export const DUTY = ensureActions({
	// Duty actions go here
})
